<template>
<div>
    <Box  @close="cerrar($event)">
        <template #top>Nueva Devolución</template>
        <template #center>
            <div class="nj-panel">
                <div class="nj-panel-content">
                    <SearchBox label="Solicitante" itemKey="emp_id" :source="solicitantes" :labelFunction="(item) => item.emp_nombre_completo" id="di-items" :searchFunction="buscarSolicitante"
                        @selectItem="seleccionarSolicitante($event)">
                        <template #default="data">
                            {{ data.item.emp_nombre_completo }}
                        </template>
                    </SearchBox>
                    <br>
                    <div v-if="lista_asignacion_items_detalle">
                        <div class="nj-data-grid-header asignaciones">
                            <div>N°</div>
                            <div>Producto</div>
                            <div>Autorizador</div>
                            <div>Solicitante</div>
                            <div>Cantidad asignada</div>
                            <div>Cantidad a devolver</div>
                            <div>Retorno (días)</div>
                            <div>Notas</div>
                        </div>
                        <div class="nj-data-grid-content asignaciones" v-for="item in lista_asignacion_items_detalle" :key="item.aid_id">
                            <div>{{ item.ait_id }}</div>
                            <div>{{ item.prv_nombre }}</div>
                            <div>{{ item.emp_autorizador_nombre }}</div>
                            <div>{{ item.emp_solicitante_nombre }}</div>
                            <div>{{ item.aid_cantidad }}</div>
                            <div>
                                <input type="text" class="nj-text" v-model="item.did_cantidad">
                            </div>
                            <div>{{ item.prv_retorno_estimado }}</div>
                            <div>
                                <input type="text" class="nj-text" v-model="item.did_notas">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #bottom>
            <Button label="Registrar" icon="save" @click="registrar()"></Button>
        </template>
    </Box>
</div>
</template>

<script>
import { AsignacionItemsService, DevolucionItemsService, EmpleadoService, ResponseStatus } from "../../rest"
import Toast from "../../util/toast"
import { UsuarioService } from "../../rest"
import { Box, Button, InputSelect, InputText, SearchBox } from "../components"

export default {
    name: "RegistrarDevolucionItems",
    components: {
        Box,
        InputText,
        InputSelect,
        SearchBox,
        Button,
    },
    data() {
        return {
            emp_solicitante: null,
            emp_solicitante_nombre: null,
            solicitantes: [],
            lista_asignacion_items_detalle: [],
        }
    },
    methods: {
        cerrar(condition) {
            this.reiniciarBusquedas()
            this.$emit("close", condition)
        },
        reiniciarBusquedas() {
            this.solicitantes = []
        },
        buscarSolicitante(emp_nombre_completo) {
            EmpleadoService
                .buscar({
                    empleado: {
                        emp_nombre_completo,
                        pry_id: UsuarioService.getUsuario().pry_id,
                    }
                })
                .then(response => {
                    this.solicitantes = response.data
                })
                .catch(error => {
                    Toast.error(error)
                    
                })

        },
        seleccionarSolicitante(solicitante) {
            AsignacionItemsService
                .buscarDetalle({
                    asignacion_items_detalle: {
                        pry_id: UsuarioService.getUsuario().pry_id,
                        emp_solicitante: solicitante.emp_id
                    }
                })
                .then(response => {
                    this.lista_asignacion_items_detalle = response.data
                    this.lista_asignacion_items_detalle.forEach(item => {
                        item.did_cantidad = item.aid_saldo,
                            item.did_notas = null
                    })
                })
                .catch(error => {
                    Toast.error(error)
                    
                })
        },
        registrar() {
            let devolucion_items = {
                ait_id: null,
                usu_registrador: UsuarioService.getUsuario().usu_id,
                pry_id: UsuarioService.getUsuario().pry_id,
                lista_devolucion_items_detalle: []
            }
            this.lista_asignacion_items_detalle.forEach(item => {
                if (!devolucion_items.ait_id) {
                    devolucion_items.ait_id = item.ait_id
                }
                devolucion_items.lista_devolucion_items_detalle.push({
                    aid_id: item.aid_id,
                    did_cantidad: item.did_cantidad,
                    did_notas: item.did_notas,
                    pal_id: item.pal_id
                })
            })
            DevolucionItemsService
                .registrar(devolucion_items)
                .then(response => {
                    Toast.success(response.message)
                    this.cerrar(true)
                })
                .catch(error => {
                    Toast.error(error)
                    
                })
        },
    },
    mounted() {

    }
}
</script>

<style scoped>
.asignaciones {
    grid-template-columns: 60px 1fr 1fr 1fr 80px 100px 60px 1fr;
}
</style>